import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getAnalyticsConsent,
  initialiseAnalytics,
  setAnalyticsConsent,
  trackPageView,
} from '../../services/analytics';

export function AnalyticsConsent() {
  const location = useLocation();
  const [consent, setConsent] = useState(getAnalyticsConsent);

  useEffect(() => {
    if (consent === 'granted') initialiseAnalytics();
  }, [consent]);

  if (consent !== 'unset') return null;

  const choose = (choice: 'granted' | 'denied') => {
    setAnalyticsConsent(choice);
    setConsent(choice);
    if (choice === 'granted') {
      initialiseAnalytics();
      trackPageView(`${location.pathname}${location.search}`);
    }
  };

  return (
    <aside
      aria-label="Analytics choice"
      className="z-20 border-b border-slate-300 bg-white px-4 py-3 shadow-sm sm:flex sm:items-center sm:justify-between sm:gap-4"
    >
      <div>
        <p className="text-sm font-semibold text-slate-950">Optional usage analytics</p>
        <p className="mt-1 text-sm leading-5 text-slate-600">
          ModelMap can send page and feature events to Google Analytics. Search text and catalog data are not sent.{' '}
          <Link to="/privacy" className="font-semibold text-blue-700 hover:underline">Privacy details</Link>
        </p>
      </div>
      <div className="mt-3 flex shrink-0 flex-wrap gap-2 sm:mt-0">
        <button type="button" onClick={() => choose('granted')} className="console-button-primary">
          Allow analytics
        </button>
        <button type="button" onClick={() => choose('denied')} className="console-button-secondary">
          Decline
        </button>
      </div>
    </aside>
  );
}
